<h2 mat-dialog-title>{{ 'MEETINGS.ADMIN.BOARD_PACK.DIALOG_TITLE' | translate }}</h2>
<mat-dialog-content>
  <p>
    {{ 'MEETINGS.ADMIN.BOARD_PACK.DIALOG_DESCRIPTION' | translate }}
    @if (hasExistingBoardPack) {
      {{ 'MEETINGS.ADMIN.BOARD_PACK.DIALOG_DESCRIPTION_REPLACE_ADDENDUM' | translate }}
    }
  </p>
  <app-file-upload
    [acceptedFileTypes]="['pdf']"
    [maxPages]="MAX_BOARD_PACK_PAGES"
    maxPagesErrorMessage="MEETINGS.ADMIN.BOARD_PACK.MAX_PAGES_ERROR"
    [maxFileSizeBytes]="MAX_BOARD_PACK_UPLOAD_BYTES"
    maxFileSizeErrorMessage="MEETINGS.ADMIN.BOARD_PACK.MAX_FILE_SIZE_ERROR"
    type="board-pack"
    (fileChange)="onFileChange($event)"
    (pageLimitExceeded)="onPageLimitExceeded($event)"
    (fileSizeLimitExceeded)="onFileSizeLimitExceeded($event)"
  ></app-file-upload>
  @if (submitErrorMessage) {
    <div class="submit-error" role="alert">{{ submitErrorMessage | translate }}</div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="isSubmitting">{{ 'COMMON.CANCEL' | translate }}</button>
  <button mat-flat-button color="primary" (click)="submit()" [disabled]="isSubmitDisabled">
    @if (isSubmitting) {
      <mat-spinner [diameter]="18"></mat-spinner>
    } @else {
      {{ 'MEETINGS.ADMIN.BOARD_PACK.SUBMIT' | translate }}
    }
  </button>
</mat-dialog-actions>
